import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EmptyState from "../../../../components/EmptyState";
import { SectionLoader } from "../../../../components/PageLoader";
import { getTransactions, getPendingTransactions } from "../../../../redux/actions/walletActions";
import Pagination from "../../../../components/Pagination";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

const TransactionHistory = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const perPage = 20;

  const { transactions } = useSelector((state) => state.wallet);
  let items = [];
  if (transactions && transactions.data && Array.isArray(transactions.data["0"])) {
    items = transactions.data["0"];
  } else if (transactions && transactions.data && Array.isArray(transactions.data)) {
    items = transactions.data;
  } else if (transactions && Array.isArray(transactions["0"])) {
    items = transactions["0"];
  } else if (Array.isArray(transactions)) {
    items = Array.isArray(transactions[0]) ? transactions[0] : transactions;
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLoading(true);
    
    Promise.all([
      getTransactions(dispatch, page, perPage),
      getPendingTransactions()
    ]).then(([transactionResult, pendingResult]) => {
      console.log("Transaction pagination result:", transactionResult);
      console.log("Pending transactions result:", pendingResult);
      
      if (transactionResult) {
        const totalCount = parseInt(transactionResult.data?.total_item_count || transactionResult.total_item_count || 0, 10);
        const pages = Math.ceil(totalCount / perPage);
        console.log("Total count:", totalCount, "Pages:", pages);
        setTotalPages(pages);
      }
      
      if (pendingResult && pendingResult.data) {
        setPendingTransactions(Array.isArray(pendingResult.data) ? pendingResult.data : []);
      }
    }).finally(() =>
      setLoading(false)
    );
  }, [dispatch, page]);

  // Combine pending and regular transactions, with pending at the top
  const allTransactions = [...pendingTransactions, ...items];
  
  // Group transactions by date
  const grouped = allTransactions.reduce((acc, tx) => {
    const day = moment(tx.date_created).format("DD MMM YYYY");
    if (!acc[day]) acc[day] = [];
    acc[day].push(tx);
    return acc;
  }, {});

  return (
    <div className={classes.root}>

      {/* Header */}
      <div className={classes.header}>
        <div>
          <div className={classes.title}>Transaction History</div>
          <div className={classes.subtitle}>
            {allTransactions.length > 0 ? `${allTransactions.length} transactions${pendingTransactions.length > 0 ? ` (${pendingTransactions.length} pending)` : ""}` : "All your past transactions"}
          </div>
        </div>
      </div>

      {/* Loading */}
      {loading && <SectionLoader />}

      {/* Empty */}
      {!loading && allTransactions.length === 0 && (
        <div className={classes.emptyWrap}>
          <EmptyState text="No transactions yet" />
        </div>
      )}

      {/* Transaction groups */}
      {!loading && allTransactions.length > 0 && (
        <>
          <div className={classes.list}>
            {Object.entries(grouped).map(([day, txs]) => (
              <div key={day}>

                {/* Day label */}
                <div className={classes.dayLabel}>{day}</div>

                {/* Transactions for this day */}
                <div className={classes.group}>
                  {txs.map((transaction, idx) => {
                    const isCredit = transaction.transactionType === "credit";
                    const isPending = transaction.status === "pending" || transaction.state === "pending";
                    return (
                      <div
                        key={transaction.id}
                        className={classes.row}
                        style={{
                          borderBottom:
                            idx < txs.length - 1
                              ? "1px solid #F3F4F6"
                              : "none",
                          backgroundColor: isPending ? "#FFF9E6" : "transparent",
                        }}
                      >
                        {/* Left: icon + info */}
                        <div className={classes.rowLeft}>
                          <div
                            className={classes.iconWrap}
                            style={{
                              background: isPending ? "#FFE082" : (isCredit ? "#EDFAF4" : "#FEF2F2"),
                            }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              {isCredit ? (
                                <path
                                  d="M8 13V3M3 8l5-5 5 5"
                                  stroke="#16A34A"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              ) : (
                                <path
                                  d="M8 3v10M3 8l5 5 5-5"
                                  stroke="#DC2626"
                                  strokeWidth="1.8"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              )}
                            </svg>
                          </div>
                          <div>
                            <div className={classes.desc}>
                              {transaction.description}
                              {/* {isPending && (
                                <span style={{ 
                                  marginLeft: "8px", 
                                  padding: "2px 8px", 
                                  background: "#FFA726", 
                                  color: "#fff", 
                                  borderRadius: "12px", 
                                  fontSize: "10px", 
                                  fontWeight: 600,
                                  textTransform: "uppercase"
                                }}>
                                  Pending
                                </span>
                              )} */}
                            </div>
                            <div className={classes.time}>
                              {moment(transaction.date_created).format("h:mm a")}
                              {isPending && transaction.release_at && (
                                <span style={{ marginLeft: "8px", color: "#F57C00" }}>
                                  • Releases {moment(transaction.release_at).format("MMM DD, YYYY")}
                                </span>
                              )}
                            </div>
                            {isPending && (
                              <div style={{
                                marginTop: "6px",
                                padding: "6px 10px",
                                background: "#FFF3E0",
                                border: "1px solid #FFE0B2",
                                borderRadius: "6px",
                                fontSize: "11px",
                                color: "#E65100",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px"
                              }}>
                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                                  <path d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 13c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" fill="#F57C00"/>
                                  <path d="M7.5 4h1v5h-1V4zm0 6h1v1h-1v-1z" fill="#F57C00"/>
                                </svg>
                                <span>
                                  Referral reward will be credited after 30-day waiting period
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Right: amount */}
                        <div
                          className={classes.amount}
                          style={{ color: isPending ? "#F57C00" : (isCredit ? "#16A34A" : "#DC2626") }}
                        >
                          {isCredit ? "+" : "−"}
                          {transaction.amount}{" "}
                          <span className={classes.currency}>
                            {transaction.currency}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className={classes.pagination}>
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={(newPage) => setPage(newPage)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    padding: "24px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "24px",
  },
  title: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#032250",
  },
  subtitle: {
    fontSize: "13px",
    color: "#7F91A7",
    marginTop: "3px",
  },
  emptyWrap: {
    paddingTop: "40px",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  dayLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#7F91A7",
    marginBottom: "8px",
    paddingLeft: "4px",
  },
  group: {
    background: "#FFFFFF",
    border: "1px solid #EFEFEF",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0px 1px 4px rgba(0,0,0,0.05)",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 18px",
    transition: "background 0.15s",
    "&:hover": {
      background: "#F9FAFB",
    },
  },
  rowLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  iconWrap: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  desc: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#032250",
    maxWidth: "280px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  time: {
    fontSize: "12px",
    color: "#7F91A7",
    marginTop: "2px",
  },
  amount: {
    fontSize: "14px",
    fontWeight: 600,
    flexShrink: 0,
  },
  currency: {
    fontSize: "11px",
    fontWeight: 500,
    opacity: 0.75,
  },
  pagination: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "center",
  },
});

export default TransactionHistory;